import { useEffect, useState } from 'react';
import { APP_STORE_URL } from '../../constants/storeUrls';
import { trackEvent, WEB_STORE_CLICK } from '../../lib/analytics';
import { isAndroid } from '../../lib/inAppBrowser';
import { Button } from './Button';

function pickStoreTarget(): { href: string; platform: 'ios' | 'android' } {
  if (typeof navigator === 'undefined') {
    return { href: APP_STORE_URL, platform: 'ios' };
  }
  if (isAndroid()) {
    return { href: '/get', platform: 'android' };
  }
  return { href: APP_STORE_URL, platform: 'ios' };
}

export function DownloadFreeButton() {
  const [store, setStore] = useState(pickStoreTarget());

  useEffect(() => {
    setStore(pickStoreTarget());
  }, []);

  function handleClick() {
    void trackEvent(WEB_STORE_CLICK, { platform: store.platform, location: 'nav' });
  }

  return (
    <Button
      variant="primary"
      href={store.href}
      target={store.href.startsWith('http') ? '_blank' : undefined}
      rel={store.href.startsWith('http') ? 'noopener noreferrer' : undefined}
      onClick={handleClick}
    >
      Get the App
    </Button>
  );
}
